import { css } from 'aphrodite';
import * as React from 'react';
import { Pill } from '../../../../web/components-v2/Pill';
import { CallLogUrlFilters, secondaryFilterChips } from '../callLogFilters';
import { styleSheet } from './styles';

interface IProps {
	filters: CallLogUrlFilters;
	managerName?: string;
	onRemove: (key: keyof CallLogUrlFilters) => void;
}

export const ActiveFilterChips: React.FC<IProps> = ({ filters, managerName, onRemove }) => {
	const chips = secondaryFilterChips(filters, { managerName });
	if (!chips.length) {
		return null;
	}
	return (
		<div className={css(styleSheet.chips)}>
			{chips.map(chip => (
				<Pill
					key={chip.key}
					variant='tag'
					color='gray'
					size='medium'
					label={chip.label}
					value={chip.key}
					onRemove={() => onRemove(chip.key)}
				/>
			))}
		</div>
	);
};
